<template>
  <v-menu
    offset-y
    :close-on-content-click="false"
    v-model="isOpen"
    max-height="300px"
  >
    <template v-slot:activator="{ on }">
      <v-btn small icon v-on="on" dark flat color="primary" :aria-label="$t('selectPackaging')">
        <v-icon>expand_more</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-text-field
        v-if="enableSearch"
        v-model="searchText"
        :label="$t('search')"
        :placeholder="$t('searchPackagings')"
        prepend-icon="search"
        single-line
        hide-details
        class="px-3 pt-3 pb-2"
        clearable
        @click.stop
      ></v-text-field>
      <v-list>
        <v-list-tile
          v-for="item in filteredPackagings"
          :key="item.id"
          @click="onSelectPackaging(item)"
        >
          <v-list-tile-content>
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
            <v-list-tile-sub-title v-if="showDetails">
              {{ formatPackagingDetails(item) }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile v-if="filteredPackagings.length === 0">
          <v-list-tile-content>
            <v-list-tile-title class="grey--text">
              {{ $t('noPackagingsFound') }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'PackagingSelector',
  props: {
    packagings: {
      type: Array,
      default: () => []
    },
    showDetails: {
      type: Boolean,
      default: false
    },
    enableSearch: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      isOpen: false,
      searchText: ''
    }
  },
  computed: {
    filteredPackagings () {
      if (!this.searchText) {
        return this.packagings
      }
      const search = this.searchText.toLowerCase()
      return this.packagings.filter(pkg =>
        pkg.name && pkg.name.toLowerCase().includes(search)
      )
    }
  },
  methods: {
    onSelectPackaging (item) {
      this.$emit('select', item)
      this.isOpen = false
      this.searchText = ''
    },
    formatPackagingDetails (pkg) {
      const length = pkg.length || '-'
      const width = pkg.width || '-'
      const height = pkg.height || '-'
      const weight = pkg.weight || '-'
      const unit = pkg.isMeasurementMetric ? 'cm' : '"'
      const weightUnit = pkg.isMeasurementMetric ? 'kg' : 'lb'
      return `${length}x${width}x${height}${unit}, ${weight}${weightUnit}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PackagingSelector.vue